<template>
    <v-dialog v-model="dialog" width="750px">
        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                              Delete Photo Assignment {{hsfo.huis_code }}
            </v-card-title>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="12" class="px-2">
                        <v-alert
                            border="right"
                            colored-border
                            type="error"
                            elevation="2">
                            Are you sure you want to delete this photo assignment?
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="dialog = false" :disabled="uploading">No</v-btn>
                <v-btn class="error mx-2" small @click="deleteHsfo" :loading="uploading">Yes</v-btn>
                
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      hsfo: { huis_code: '' },
      dialog: false,
      viewHsfoValid: false,
      uploading: false,
      huis_encrid: null,
      hsfo_description: null,
      hsfo_deadline: null,
      hsfo_fotograaf: null,
      hsfo_contact: null,
      hsfo_status: null,
      hsfo_prio: null,
      hsfo_hfot: [],
      fttg_nrKeuzes: [],
      hsft_foto: null,
      hsft: {},
      url: null,
      image:{
        size:'',
        height:'',
        width:'',
        src: null
      },
      fttg_nrRules: [
          v => !!v || "A Tag is required"
      ],
      hsft_fotoRules: [
          v => !!v || "A photo is required"
      ],
      priocolor: {
        Low: '#D1E2FF',
        Medium: '#74EBE1',
        High: '#DC043B'
      },
      statuscolor: {
        Signedup: '#FAD2FC',
        Readytoshoot: '#FFEAB6',
        Offered: '#D1E2FF',
        Assigned: '#88DBFF',
        Completed: '#9AE095',
        Rejected: '#41454D',
        Onhold: '#FFB68E'
      },
      statuscolor_hfot: {
        Notapplicable: '#DC043B',
        Pending: '#D1E2FF',
        Completed: '#9AE095'
      }
    }
  },
  mounted() {   /* Work around voor Safari */
     let inputs = document.querySelectorAll('.v-file-input input');
         [...inputs].forEach((input) => {
              input.remove()
          })
  },
  methods: {
    open(hsfo_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hsfo_encrid = hsfo_encrid;
    },
    deleteHsfo() {
      this.$axios
        .post("ares/json/ares/huis/hsfo/deleteHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "deleteHsfo"
          },
          deleteHsfo: {
            hsfo_encrid: this.hsfo_encrid,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.deleteHsfo.text,
              color: res.data.deleteHsfo.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    }
  }
}
</script>

